// extracted by mini-css-extract-plugin
export default {"panel":"NoAccess_panel__th2cn","form":"NoAccess_form__pouv-","title":"NoAccess_title__cVT8T","field":"NoAccess_field__3G8lC","label":"NoAccess_label__mT081"};